export default "__VITE_ASSET__vv96gxlH__"